// src/components/signout-form/SignOutForm.tsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useAuth } from 'auth/AuthContext';

interface SignOutFormProps {
	formClasses?: string;
	btnClasses?: string;
	shouldLogOut?: boolean;
	hide?: boolean;
}

export const SignOutForm = ({
	formClasses,
	btnClasses,
	shouldLogOut,
	hide,
}: SignOutFormProps) => {
	const { t } = useTranslation('header');
	const { logout } = useAuth();

	useEffect(() => {
		if (shouldLogOut) {
			logout();
		}
	}, [shouldLogOut, logout]);

	return (
		<div
			className={cn(formClasses, {
				'display-none': hide,
			})}
		>
			<button type="button" className={btnClasses} onClick={logout}>
				{t('sign_out')}
			</button>
		</div>
	);
};
